export default "__VITE_ASSET__Jd9tCwXI__"